import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import '../static/element-ui/element/theme/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import router from './router'
import store from './store'
import './assets/css/global.css'
import 'normalize.css'

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
